export default "__VITE_ASSET__CrbPlttw__"